import React, { createContext, useContext, useState } from "react";
import { useViewport } from "../hooks/useViewport";

interface DrawerContextType {
  isCollapsed: boolean;
  toggleCollapsed: () => void;
  setCollapsed: (collapsed: boolean) => void;
}

const DrawerContext = createContext<DrawerContextType | undefined>(undefined);

export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (context === undefined) {
    throw new Error("useDrawer must be used within a DrawerProvider");
  }
  return context;
};

export const DrawerProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isMobile } = useViewport();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapsed = () => {
    if (isMobile) {
      // dont allow collapsing the drawer to compact mode on mobile
      return;
    }

    setIsCollapsed((prev) => !prev);
  };

  const setCollapsed = (collapsed: boolean) => {
    if (isMobile) {
      return;
    }

    setIsCollapsed(collapsed);
  };

  return (
    <DrawerContext.Provider
      value={{ isCollapsed, toggleCollapsed, setCollapsed }}
    >
      {children}
    </DrawerContext.Provider>
  );
};
